/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './page-not-found.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/di/injector';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/change_detection';
import * as import8 from '../shared/utils.service';
import * as import9 from '../shared/intl.service';
import * as import10 from '../shared/config.service';
import * as import11 from '@angular/router/src/router';
import * as import12 from '@angular/router/src/router_state';
import * as import13 from '@angular/core/src/metadata/view';
import * as import14 from '@angular/core/src/linker/component_factory';
import * as import15 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import16 from '../shared/intl.pipe';
import * as import17 from '@angular/core/src/linker/template_ref';
import * as import18 from '@angular/common/src/directives/ng_if';
export class Wrapper_PageNotFoundComponent {
  context:import0.PageNotFoundComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any) {
    this.changed = false;
    this.context = new import0.PageNotFoundComponent(p0,p1,p2,p3,p4);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_PageNotFoundComponent_Host:import2.RenderComponentType = (null as any);
class _View_PageNotFoundComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _PageNotFoundComponent_0_4:Wrapper_PageNotFoundComponent;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_PageNotFoundComponent_Host0,renderType_PageNotFoundComponent_Host,import6.ViewType.HOST,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer,'ng-component',import4.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_PageNotFoundComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._PageNotFoundComponent_0_4 = new Wrapper_PageNotFoundComponent(this.parentInjector.get(import8.UtilsService),this.parentInjector.get(import9.IntlService),this.parentInjector.get(import10.ConfigService),this.parentInjector.get(import11.Router),this.parentInjector.get(import12.ActivatedRoute));
    this._appEl_0.initComponent(this._PageNotFoundComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._PageNotFoundComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.PageNotFoundComponent) && (0 === requestNodeIndex))) { return this._PageNotFoundComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._PageNotFoundComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) {
      if ((this.numberOfChecks === 0)) { this._PageNotFoundComponent_0_4.context.ngAfterContentInit(); }
      this._PageNotFoundComponent_0_4.context.ngAfterContentChecked();
    }
    this._PageNotFoundComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_PageNotFoundComponent_Host0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_PageNotFoundComponent_Host === (null as any))) { (renderType_PageNotFoundComponent_Host = viewUtils.createRenderComponentType('',0,import13.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_PageNotFoundComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const PageNotFoundComponentNgFactory:import14.ComponentFactory<import0.PageNotFoundComponent> = new import14.ComponentFactory<import0.PageNotFoundComponent>('ng-component',viewFactory_PageNotFoundComponent_Host0,import0.PageNotFoundComponent);
const styles_PageNotFoundComponent:any[] = ([] as any[]);
var renderType_PageNotFoundComponent:import2.RenderComponentType = (null as any);
class _View_PageNotFoundComponent0 extends import1.AppView<import0.PageNotFoundComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _anchor_8:any;
  /*private*/ _appEl_8:import3.AppElement;
  _TemplateRef_8_5:any;
  _NgIf_8_6:import15.Wrapper_NgIf;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _pipe_intl_0:import16.IntlPipe;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_PageNotFoundComponent0,renderType_PageNotFoundComponent,import6.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray8(6,'class','fill full-screen','id','full-screen-home','style','background-image:url(\'/data/images/platine-v2-home-web-clean.jpg\'); position: relative'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','opacity-light bg-dark-gray'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','slider-typography text-center'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_4,'div',new import4.InlineArray2(2,'class','slider-text-middle-main pull-left'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._anchor_8 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._appEl_8 = new import3.AppElement(8,6,this,this._anchor_8);
    this._TemplateRef_8_5 = new import17.TemplateRef_(this._appEl_8,viewFactory_PageNotFoundComponent1);
    this._NgIf_8_6 = new import15.Wrapper_NgIf(this._appEl_8.vcRef,this._TemplateRef_8_5);
    this._text_9 = this.renderer.createText(this._el_6,'\n        ',(null as any));
    this._text_10 = this.renderer.createText(this._el_4,'\n    ',(null as any));
    this._text_11 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_intl_0 = new import16.IntlPipe();
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._anchor_8,
      this._text_9,
      this._text_10,
      this._text_11
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.TemplateRef) && (8 === requestNodeIndex))) { return this._TemplateRef_8_5; }
    if (((token === import18.NgIf) && (8 === requestNodeIndex))) { return this._NgIf_8_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_8_0_0:any = this.context.currentLanguage;
    this._NgIf_8_6.check_ngIf(currVal_8_0_0,throwOnChange,false);
    this._NgIf_8_6.detectChangesInInputProps(this,this._anchor_8,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_PageNotFoundComponent0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<import0.PageNotFoundComponent> {
  if ((renderType_PageNotFoundComponent === (null as any))) { (renderType_PageNotFoundComponent = viewUtils.createRenderComponentType('',0,import13.ViewEncapsulation.None,styles_PageNotFoundComponent,{})); }
  return new _View_PageNotFoundComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_PageNotFoundComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  /*private*/ _expr_12:any;
  _pipe_intl_0_0:any;
  /*private*/ _expr_14:any;
  _pipe_intl_0_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_PageNotFoundComponent1,renderType_PageNotFoundComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_12 = import7.UNINITIALIZED;
    this._expr_14 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','slider-home slider-text-middle padding-left-right-px'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_3 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class',''),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n                    ',(null as any));
    this._el_5 = import4.createRenderElement(this.renderer,this._el_3,'a',new import4.InlineArray2(2,'class','highlight-link-text xs-line-height-18 pointer highlight-button highlight-button-cover btn btn-medium button xs-margin-bottom-five'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_3,'\n                ',(null as any));
    this._text_8 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,this._el_0,'h1',new import4.InlineArray2(2,'class','white-text font-weight-100 letter-spacing-2'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_5,'click',this.eventHandler(this._handle_click_5_0.bind(this)));
    this._pipe_intl_0_0 = import4.pureProxy2((<_View_PageNotFoundComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_PageNotFoundComponent0>this.parent)._pipe_intl_0));
    this._pipe_intl_0_1 = import4.pureProxy2((<_View_PageNotFoundComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_PageNotFoundComponent0>this.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_12:any = import4.interpolate(1,'\n                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_0,(<_View_PageNotFoundComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.HOME.CATALOGUE_GO),this.parent.context.currentLanguage)),'\n                    ');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_12,currVal_12))) {
      this.renderer.setText(this._text_6,currVal_12);
      this._expr_12 = currVal_12;
    }
    valUnwrapper.reset();
    const currVal_14:any = import4.interpolate(1,'\n                ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_1,(<_View_PageNotFoundComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.COMMON.PAGE_NOT_FOUND.TITLE),this.parent.context.currentLanguage)),'\n                ');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_14,currVal_14))) {
      this.renderer.setText(this._text_10,currVal_14);
      this._expr_14 = currVal_14;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this.parent.context.utils.lLink('catalogue',this.parent.context.currentLanguage)) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_PageNotFoundComponent1(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_PageNotFoundComponent1(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/page-not-found.component.ngfactory.ts